module.exports = {
	totalWard: 11
};
